import { googlePlayLink, itunesLink } from "../../constants/links"

import AppStoreBtnEN from "../../images/app-store-en.svg"
import AppStoreBtnES from "../../images/app-store.svg"
import Container from "../container/container"
import GooglePlayBtnEN from "../../images/google-play-en.svg"
import GooglePlayBtnES from "../../images/google-play.svg"
import Link from "../link/link"
import LogoFooter from "../../images/logo-footer.svg"
import React from "react"
import styles from "./footer.module.css"
import { useTranslation } from "react-i18next"

export default function Footer({
  pageFaqUrl = "/faq/",
  pageTermsUrl = "/terms/",
  pagePrivacyUrl = "/privacy/",
}) {
  const { t, i18n } = useTranslation()

  let AppStoreBtn = AppStoreBtnEN
  let GooglePlayBtn = GooglePlayBtnEN

  if (i18n.language === "es") {
    AppStoreBtn = AppStoreBtnES
    GooglePlayBtn = GooglePlayBtnES
  }

  const helpUrl = i18n.language === "en" ? "/help/" : "/ayuda/"
  const currentYear = new Date().getFullYear()

  let renderPrivacyLink
  if (pagePrivacyUrl.includes("https://")) {
    renderPrivacyLink = (
      <a href={pagePrivacyUrl} className={styles.footerLinksItem}>
        {t("footer.privacy")}
      </a>
    )
  } else {
    renderPrivacyLink = (
      <Link to={pagePrivacyUrl} classNames={styles.footerLinksItem}>
        {t("footer.privacy")}
      </Link>
    )
  }

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.footerWrapper}>
          <Link to="/" classNames={styles.footerLogoLink}>
            <img
              src={LogoFooter}
              alt="Puma FastPay"
              className={styles.footerLogoImg}
            />
          </Link>
          <nav id="footer-links" className={styles.footerLinks}>
            <a href={helpUrl} className={styles.footerLinksItem}>
              {t("footer.help")}
            </a>
            <Link to={pageFaqUrl} classNames={styles.footerLinksItem}>
              {t("footer.faq")}
            </Link>
            <Link to={pageTermsUrl} classNames={styles.footerLinksItem}>
              {t("footer.terms")}
            </Link>
            {renderPrivacyLink}
          </nav>
        </div>
        <div className={styles.footerWrapper}>
          <nav className={styles.footerDownloadButtons}>
            <a href={itunesLink} className={styles.footerDownloadButtonsButton}>
              <img
                src={AppStoreBtn}
                alt="Puma FastPay App Store"
                className={styles.footerDownloadButtonsButtonImg}
              />
            </a>
            <a
              href={googlePlayLink}
              className={styles.footerDownloadButtonsButton}
            >
              <img
                src={GooglePlayBtn}
                alt="Puma FastPay Google Play"
                className={styles.footerDownloadButtonsButtonImg}
              />
            </a>
          </nav>
          <p className={styles.footerCopy}>
            © {currentYear} &nbsp;
            <span className={styles.footerCopyLink}>Alias Payments</span>, Inc.
            All Rights Reserved.
          </p>
        </div>
      </Container>
    </footer>
  )
}
